import React, { Component } from "react";
import axios from "axios";
import {
  Row,
  Col,
  Card,
  Icon,
  Button,
  List,
  Avatar,
  Select,
  Checkbox,
  Modal,
  Input,
  message,
  Tag,
  Tooltip,
  Popover
} from "antd";
import F from "../../../Functions";
import Thumb from "../images/bfile-thumb.jpg";
import UserEditModal from "../parts/user-edit-modal";
import { Translate } from "react-translated";
import ActionMenu from "../menu";
import {
  AGENCY_MANAGER,
  BAD_PHONE_NUMBER_REPORTED,
  FAILED_TO_UPDATE_BAD_PHONE_NUMBER_STATUS,
  LAUNCH_CALCULATOR_POP_OVER,
  NO_USERS_TO_NOTIFY,
  PROFILE_PDF_HEADERS,
  REQUEST_CALL_POP_OVER,
  REVIEWSCHEDULER,
  VONBOARDER,
  VONSCHEDULER,
  get_label_from_value,
} from "../../../utils/Constants";
import ReadMore from "../../../components/read-more";
import ShowReferrals from "../showReferrals";
import moment from "moment";
import "./Customer.css";

// icons import
import NotePadIcon from "../images/new/Symbol.png";
import dataBaseIcon from "../images/new/database.png";
import MailIcon from "../images/new/mail.png";
import PhoneCallIcon from "../images/new/phone-call.png";
import UsersIcon from "../images/new/users.png";
import EditPenIcon from "../images/new/edit-pen.png";


// import modals
import SetupAppointment from "../parts/setup-appointment-modal";
import SetupAppointmentVon from "../parts/setup-appointment-modal-vo";
import AppointmentActionModal from "./AppointmentActionModal";
import CallBackRequestedModal from "./CallBackRequestedModal";
import DistanceAndTimezone from "./DistanceAndTimezone";
import { withRouter } from "react-router-dom";
import { useBoundStore } from '../../../store/useBoundStore';
import OptimizedReadMore from "./OptimizedReadMore";
import { CREATE_CALL_ATTEMPT_HISTORY, CREATE_NOTES, CREATE_NOTIFICATION, GET_ALL_USER_FOR_BAD_PHONE_NUMBER_NOTIFICATION } from "../../../utils/Api_enums";

import { listenToWindowWidth } from "../../../utils/windowWidthListener";


const { Option } = Select;
const confirm = Modal.confirm;

class CustomerProfile extends Component {
  constructor(props) {
    super(props);
  }
  state = {
    setup_appointment_modal: false,
    setup_appointment_modal_von: false,
    not_interested_modal: false,
    not_reached_modal: false,
    not_responsive_modal: false,
    call_back_requested_modal: false,
    bad_phone_number_modal: false,
    bad_phone_number_reason: "",
    notificationLoading: false,
    bad_phone_number_status: this.props.bfile.bad_phone_number_status || false,
    selectedRoleFilter: useBoundStore.getState().RSFSCardFilters.defaultToggleUserRole,
    windowWidth: window.innerWidth,
    has_access: false


  };

  componentDidMount() {
    const { bfile, user } = this.props;
    this.check_if_scheduler_has_access(bfile);
    if (bfile.bad_phone_number_status) {
      this.setState({
        bad_phone_number_status: bfile.bad_phone_number_status
      })
    }
    this.cleanupResizeListener = listenToWindowWidth((width) => {
      this.setState({ windowWidth: width });
    });
  }

  //commented this since bad phone number label was vanishing on marking it 
  // componentDidUpdate = (prevProps, prevState) => {
  //   if (prevState.bad_phone_number_status !== this.props.bfile.bad_phone_number_status) {
  //     this.setState({
  //       bad_phone_number_status: this.props.bfile.bad_phone_number_status
  //     })
  //   }
  // }
  componentWillUnmount() {
    this.cleanupResizeListener();
  }

  showConfirmationModal = () => {
    Modal.confirm({
      title: "Confirmation",
      content: "Call Attempted multiple times, do you still want to continue?",
      onOk: () => {
        setTimeout(
          () => this.setState({ setup_appointment_modal_von: true }),
          200
        );
      },
      okText: "Yes",
      cancelText: "No",
      okButtonProps: {
        className: 'borderRadius-28 bg-164897'
      },
      cancelButtonProps: {
        className: 'borderRadius-28'
      }
    });
  };

  check_if_scheduler_has_access = (bfile) => {

    axios.get(`/api/check_if_scheduler_has_access/${bfile.id}`)
      .then((res) => {
        if (res && res.data) {
          this.setState({ has_access: res.data.has_access })
        }

      })
      .catch((error) => {
        F.showAndHandleServerError(error);
      })
      .finally(() => {
        // this.setState({ notificationLoading: false });
      });
  }

  schedule_appointmentFunc = () => {
    const { user, bfile } = this.props;
    // this.saveCallAttemptHistory(bfile, "schedule_appointment");

    if (user.user_type === "REVIEWSCHEDULER" || this.state.selectedRoleFilter == REVIEWSCHEDULER) {
      this.setState({
        setup_appointment_modal: true,
      });
    } else if (user.user_type === "VONBOARDER" || this.state.selectedRoleFilter == VONBOARDER) {
      if (
        bfile.vob_archived != 1 &&
        bfile.vob_completed != 1 &&
        bfile.vob_attempted == 1
      ) {
        const callAttempts = F.getCallAttemptsFromBFileQuestionArray(bfile);
        if (callAttempts >= 3) {
          this.showConfirmationModal();
        } else {
          this.setState({
            setup_appointment_modal_von: true,
          });
        }
      } else {
        this.setState({
          setup_appointment_modal_von: true,
        });
      }
      //commented now because if else condition and modal opening is already written above!
      // this.setState({
      //   setup_appointment_modal_von: true,
      // });
    }
  };

  // Mark the B File as a bad phone number, save the reason as a note, and notify configured users.
  sendNotification = async (bfile) => {
    const { user } = this.props;
    const reason = this.state.bad_phone_number_reason;

    if (!reason.length) return;

    this.setState({ notificationLoading: true });

    let payload = {
      bad_phone_number_status: true
    };

    if ((user && user.user_type === REVIEWSCHEDULER) || this.state.selectedRoleFilter === REVIEWSCHEDULER) {
      payload = {
        ...payload,
        rs_date: moment(new Date()).utc().format("YYYY-MM-DD HH:mm:ss"),
        reviewer_id: user.id,
      };
    } else {
      payload = {
        ...payload,
        onboarder_id: user.id,
        onboarding_id: user.id,
        vo_claim_date: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
      };
    }

    try {
      await Promise.all([
        axios.post(CREATE_NOTES, {
          note: reason,
          bfile_id: bfile.id,
          user_id: user.id,
          action: BAD_PHONE_NUMBER_REPORTED,
          notes_type: F.getNotesType()
        }),
        axios.put(`/api/b_file/${bfile.id}`, payload)
      ]);

      this.setState({
        bad_phone_number_status: true,
        bad_phone_number_modal: false,
        bad_phone_number_reason: ""
      });

      try {
        const res = await axios.post(GET_ALL_USER_FOR_BAD_PHONE_NUMBER_NOTIFICATION, {
          agency_id: bfile.agency_id
        });
        const userIds = res.data.data || [];

        if (userIds.length) {
          const data = {
            notification_message: `The phone number for ###${bfile.first_name} ${bfile.last_name}### is invalid, please update it`,
            user_ids: userIds,
            severity: "low",
            dispatch_time: Math.floor(Date.now() / 1000),
            bfile_id: bfile.id
          };
          await axios.post(CREATE_NOTIFICATION, data);
          message.success(F.translate(`Notification Sent Successfully`));
          this.props.history.goBack();
        } else {
          message.info(F.translate(NO_USERS_TO_NOTIFY));
          this.props.history.goBack();
        }

      } catch (notificationError) {
        F.showAndHandleServerError(notificationError);
      }

      await this.props.parentInstance.init();
    } catch (error) {
      message.error(FAILED_TO_UPDATE_BAD_PHONE_NUMBER_STATUS);
      F.showAndHandleServerError(error);
    } finally {
      this.setState({ notificationLoading: false });
    }
  };


  scheduleAppointmentPermission = (user, bfile) => {
    if (user.user_type === REVIEWSCHEDULER || this.state.selectedRoleFilter == REVIEWSCHEDULER) {
      return true;
    }
    if (
      // bfile.onboarding_id !== null &&
      // bfile.vo_claim_date !== null &&
      (user.user_type === VONBOARDER || this.state.selectedRoleFilter == VONBOARDER)) {
      return true;
    }
    else {
      return false;
    }

  }

  buttoneExpirationPermission = (user, bfile) => {
    if (user.user_type === REVIEWSCHEDULER || this.state.selectedRoleFilter == REVIEWSCHEDULER) {
      return true;
    }
    if (
      // bfile.onboarding_id !== null &&
      // moment(bfile.expiration_date).isAfter(moment(), 'day') &&
      // bfile.vo_claim_date !== null &&
      (user.user_type === VONBOARDER || this.state.selectedRoleFilter == VONBOARDER)) {
      return true;
    }
    else {
      return false;
    }
  }
  // 

  claimButtonVisibility = (user, bfile) => {
    // if (bfile.vo_claim_date == null &&
    //   (user.user_type === "VONBOARDER" || this.state.selectedRoleFilter == VONBOARDER)) {
    //   return true;
    // }
    // else {
    return false;
    // }
  }
  saveCallAttemptHistory = async (bfile, action) => {
    try {
      await axios.post(CREATE_CALL_ATTEMPT_HISTORY, {
        bfile_id: bfile.id,
        scheduler_specialist_id: this.props.user.id,
        bfile_user_id: bfile.user_id,
        agency_id: bfile.agency_id,
        type_of_call: bfile.type_of_call,
        sub_type_of_call: bfile.sub_type_of_call,
        first_name: bfile.first_name,
        last_name: bfile.last_name,
        phone: bfile.phone,
        action: action
      });
    } catch (error) {
      console.error('Error saving call attempt history:', error);
    }
  }

  getUserType = (val) => {
    if (val === VONSCHEDULER) {
      return "Review Follow-Up"
    } else
      return val
  }

  claim = async (bfile_id, expiration_date) => {
    const { user } = this.props;
    this.setState({ claimLoading: true });
    try {
      await axios.put(`/api/b_file/${bfile_id}`, {
        archive: 0,
        not_interested: 0,
        onboarding_id: user.id,
        expiration_date: expiration_date,
        vo_claim_date: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
      }).then((res) => {
        setTimeout(() => {
          this.props.parentInstance.init();
        }, 200);
        // window.location.reload();
      });

      // props.history.push(`/customer/${bfile_id}`);
    } catch (error) {
      console.error("Error updating b_file:", error);
      // } finally {
      //   setLoading(false);
    } finally {
      this.setState({ claimLoading: false });
    }
  };

  // handlePhoneNumberChange = () => {
  //   const { parentInstance, bfile } = this.props;
  //   // Check if the expiration date is after today    
  //   if (moment(bfile.expiration_date).isBefore(moment(), 'day')) {
  //     message.error('Schedule-by date for this B File has expired. Kindly request call for this B File using "Request Call" button.');
  //   }
  //   else {
  //     parentInstance.setState({
  //       show_user_edit_modal: true,
  //     })
  //   }
  // }


  handlePhoneNumberChange = () => {
    const { parentInstance, bfile } = this.props;
    // Check if the expiration date is after today    
    // if (bfile.type_of_call == 'Review' && (moment(bfile.expiration_date).isBefore(moment(), 'day'))) {
    //   message.error('Schedule-by date for this B File has expired. Kindly request call for this B File using "Request Call" button.');
    // } else if (bfile.bfile_sub && bfile.bfile_sub.length > 0 && bfile.bfile_sub[0].fs_expiration_date && moment(bfile.bfile_sub[0].fs_expiration_date).isBefore(moment(), 'day')) {
    //   message.error('Schedule-by date for this B File has expired. Kindly request call for this B File using "Request Call" button.');
    // }
    // else {
    parentInstance.setState({
      show_user_edit_modal: true,
    })
    // }
  }

  render() {
    const {
      bfile,
      loading,
      user,
      show_user_edit_modal,
      noteType,
      notes_loading,
      few_notes_copy,
      notes,
      parentInstance,
    } = this.props;

    const { windowWidth } = this.state;
    const agencyInfo = useBoundStore.getState().AgencyInfo;


    let bfileAddress =
      [
        bfile.address,
        bfile.address_cont,
        bfile.city,
        bfile.state,
        bfile.zipcode,
        "U.S.",
      ]
        .filter((value) => value)
        .join(", ") || "";
    const { claimLoading } = this.state || {};
    const { notificationLoading } = this.state || {};
    const isDisabled =
      agencyInfo.review == 0 && agencyInfo.vonboard == 0;

    return (
      <div style={{ marginBottom: "10px", borderRadius: "10px" }} className="customer-profile-card-1">
        <div className="profile-main-card" style={{ borderRadius: "10px" }}>
          {/* blue header part */}
          <div
            className="card-padding-10 border-radius-10 "
            type="inner"
            // bordered={false}
            loading={loading}
            style={{ background: "#164897", color: "#FFFFFF" }}
          >
            {windowWidth > 800 && <div className="vertical-line" />}
            <Row className="center-content" gutter={32}>
              <Col span={12}>
                <div className="center-content">
                  <span className="padding-5">
                    <img
                      src={NotePadIcon}
                      alt="notepad"
                      width={16}
                      style={{ marginTop: "-5px" }}
                    />
                  </span>
                  <Tooltip
                    placement="top"
                    title={F.stripHtml(`${bfile.first_name} ${bfile.last_name}`)}
                  >
                    <span className="overlfow-text-name text-18">
                      {F.stripHtml(`${bfile.first_name} ${bfile.last_name}`)}
                    </span>
                  </Tooltip>

                  {/* show bad phone number tag when bad phone number status is true */}
                  {
                    this.state.bad_phone_number_status ? (
                      <Tag style={{
                        position: "absolute",
                        right: this.state.windowWidth <= 430 ? -180 : 0,
                        marginLeft: "10px",
                        color: "red",
                        background: "#fff"
                      }}>
                        Bad Phone Number</Tag>
                    ) : null
                  }

                </div>
              </Col>
              {/* header right */}
              {
                windowWidth > 800 && (
                  <Col span={12}>
                    <div
                      style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                    >
                      <div>
                        <span className="padding-5">
                          <img
                            src={dataBaseIcon}
                            alt="notepad"
                            width={20}
                            style={{ marginLeft: "-5px", paddingBottom: "5px" }}
                          />
                        </span>
                        <span className="text-18">Notes</span>
                      </div>
                      <div className="select-container">
                        <Icon type="search" className="search-icon-select" />
                        <Select
                          mode="multiple"
                          className="notes-dropdown"
                          style={{ width: 280, wordBreak: "" }}
                          placeholder="Select Notes Type"
                          defaultValue={[]}
                          value={noteType}
                          onChange={parentInstance.handleChangeNoteType}
                          optionLabelProp="value"
                          maxTagCount={1}
                          suffixIcon={<span>...</span>}
                        // showSearch
                        >
                          <Option value="Internal">
                            <Checkbox checked={noteType.includes("Internal")}>
                              Internal
                            </Checkbox>
                          </Option>
                          <Option value="Review Scheduler">
                            <Checkbox
                              checked={noteType.includes("Review Scheduler")}
                            >
                              Review Scheduler
                            </Checkbox>
                          </Option>
                          <Option value="Follow-up Specialist">
                            <Checkbox
                              checked={noteType.includes("Follow-up Specialist")}
                            >
                              Follow-up Specialist
                            </Checkbox>
                          </Option>
                        </Select>
                      </div>
                    </div>
                  </Col>
                )
              }
            </Row>
          </div>


          {/* card section  */}
          <div className="relative-container ">
            {windowWidth > 800 && <div className="vertical-line-2" />}
            <Row gutter={16}>
              <Col span={windowWidth > 800 ? 12 : 24}>
                <div className="padding-20 card-details">
                  <div style={{ width: windowWidth > 800 ? "65%" : "100%" }}>
                    {/* Distance and time zone container */}
                    <div>
                      <DistanceAndTimezone
                        bfile={bfile}
                      />
                    </div>
                    <div>
                      {bfile.spouse_first_name !== null &&
                        bfile.spouse_first_name !== "" ? (
                        <div className="padding-bottom-25"
                          style={{ display: "flex" }}
                        >
                          <img
                            src={UsersIcon}
                            alt="Phone Icon"
                            width={16}
                            className="customer-profile-icon"
                          />
                          <span className="text-color-label text-14 "
                            style={{ paddingRight: "5px", whiteSpace: "nowrap" }}
                          >
                            Spouse name :{" "}
                          </span>
                          <Tooltip placement="top" title={bfile.spouse_first_name + " " + bfile.spouse_last_name}>
                            <span className="text-color-value overlfow-text-wrap text-14 "
                            >
                              {bfile.spouse_first_name +
                                " " +
                                bfile.spouse_last_name}
                            </span>
                          </Tooltip>
                        </div>
                      ) : null}
                      {bfile.phone !== null && bfile.phone !== "" ? (
                        <div className="padding-bottom-25">
                          <img
                            src={PhoneCallIcon}
                            alt="Phone Icon"
                            width={16}
                            className="customer-profile-icon"
                          />
                          <span className="text-color-label text-14">
                            Phone :{" "}
                          </span>
                          <a href={`tel:${bfile.phone}`} className="text-color-value 
                          text-14 phone-link"
                          >
                            {" "}
                            {F.phone_format(bfile.phone)}
                          </a>
                          {(user.user_type === "EA" && user.id !== 2) ||
                            user.user_type === "LSP" ? (
                            <span>
                              <img
                                src={EditPenIcon}
                                alt="Edit"
                                onClick={() =>
                                  this.handlePhoneNumberChange()
                                }
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    this.handlePhoneNumberChange()
                                  }
                                }}
                                tabIndex={0}
                                style={{
                                  paddingLeft: "5px",
                                  paddingBottom: "5px",
                                  cursor: "pointer",
                                }}
                              />
                            </span>
                          ) : null}
                          {/* user edit modal open when click on edit pencil icon  */}
                          <UserEditModal
                            hideModal={() => {
                              parentInstance.setState({
                                show_user_edit_modal: false,
                              });
                            }}
                            init={parentInstance.init}
                            showModal={show_user_edit_modal}
                            bfile={bfile}
                            user={user}
                          />
                        </div>
                      ) : null}
                      {bfile.phone2 !== null && bfile.phone2 !== "" ? (
                        <div className="padding-bottom-25">
                          <img
                            src={PhoneCallIcon}
                            alt="Phone Icon"
                            width={16}
                            className="customer-profile-icon"
                          />
                          <span className="text-color-label text-14">
                            Mobile :{" "}
                          </span>
                          <span className="text-color-value text-14 ">
                            {" "}
                            {F.phone_format(bfile.phone2)}
                          </span>
                        </div>
                      ) : null}
                      {bfile.email !== null && bfile.email !== "" ? (
                        <div className="padding-bottom-25"
                          style={{ display: 'flex' }}
                        >
                          <img
                            src={MailIcon}
                            alt="Mail Icon"
                            width={16}
                            className="customer-profile-icon"
                          />
                          <span className="text-color-label text-14"
                            style={{ paddingRight: "5px", whiteSpace: "nowrap" }}
                          >
                            Email :{" "}
                          </span>
                          <Tooltip placement="top" title={bfile.email}>
                            <span className="text-color-value overlfow-text-wrap text-14">
                              {bfile.email}
                            </span>
                          </Tooltip>
                        </div>
                      ) : null}
                      {bfileAddress !== null && bfileAddress !== "" ? (
                        <div className="padding-bottom-25"
                          style={{ display: 'flex' }}
                        >
                          <img
                            src={UsersIcon}
                            alt="Mail Icon"
                            width={16}
                            className="customer-profile-icon"
                          />
                          <span className="text-color-label text-14"
                            style={{ paddingRight: "5px", whiteSpace: "nowrap" }}
                          >
                            Address :{" "}
                          </span>
                          <Tooltip placement="top" title={bfileAddress}>
                            <span className="text-color-value overlfow-text-wrap text-14">
                              {bfileAddress}
                            </span>
                          </Tooltip>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  {/* button section  */}
                  {
                    windowWidth > 800 && (
                      <div>

                        {/* two button show */}
                        {((user.user_type === "EA" && user.id !== 2) ||
                          user.user_type === "LSP") && (


                            <div className="btn-container-customer-profile">
                              <Popover
                                content={LAUNCH_CALCULATOR_POP_OVER}
                                placement="top"
                                trigger={"hover"}
                              >
                                <button
                                  className="button-size-w-171 text-12 center-button-text btn-bg-164897 margin-bottom-20"
                                  onClick={parentInstance.edit.bind(parentInstance)}
                                >
                                  <Translate text={`Edit Calculator`} />
                                </button>
                              </Popover>
                              {/* Update Intelligence Link button */}
                              {/* removed extra filters */}
                              {/* {(user.user_type && user.user_type === "EA") ||
                          (user.user_type === "SUPER_ADMIN" &&
                            parentInstance.props.history.location.state &&
                            parentInstance.props.history.location.state
                              .user_type === "BOBADMIN") ||
                          (user.user_type && user.user_type === "LSP") ? (

                          moved  button from here to top
                        ) : null} */}

                              {/* Request Call button */}
                              {((user.user_type && user.user_type === "EA") || (user.user_type && user.user_type === "LSP")) ? (
                                // (user.user_type === "SUPER_ADMIN" && parentInstance.props.history.location.state && parentInstance.props.history.location.state.user_type === "BOBADMIN") ||
                                // (user.user_type && user.user_type === "LSP")) && parentInstance.state.isRequestButtonDisable && (parentInstance.state.isRequestButtonDisable.review == 1 || parentInstance.state.isRequestButtonDisable.vonboard == 1) ? (
                                <Popover
                                  content={REQUEST_CALL_POP_OVER}
                                  placement="top"
                                  trigger={(agencyInfo.review == 0 && agencyInfo.vonboard == 0) ? [] : "hover"}
                                >


                                  <Button
                                    onClick={() =>
                                      parentInstance.setState({ send_followup_modal: true })
                                    }
                                    disabled={isDisabled}
                                    className="button-size-w-171 text-12 center-button-text"
                                    style={{
                                      backgroundColor: isDisabled ? "#d9d9d9" : "#ff7152",
                                      borderColor: isDisabled ? "#d9d9d9" : "#ff7152",
                                      color: isDisabled ? "#999" : "#fff",
                                      borderRadius: "999px",
                                      padding: "0 20px",
                                      height: "25px",
                                      minWidth: "171px",
                                      boxShadow: "none",
                                      outline: "none",
                                      opacity: 1,
                                      cursor: isDisabled ? "not-allowed" : "pointer",
                                    }}
                                    onMouseEnter={(e) => {
                                      if (isDisabled) return;

                                      e.currentTarget.style.backgroundColor = "#ff7152";
                                      e.currentTarget.style.borderColor = "#ff7152";
                                      e.currentTarget.style.color = "#fff";
                                    }}
                                    onMouseLeave={(e) => {
                                      if (isDisabled) return;

                                      e.currentTarget.style.backgroundColor = "#ff7152";
                                      e.currentTarget.style.borderColor = "#ff7152";
                                      e.currentTarget.style.color = "#fff";
                                    }}
                                  >
                                    <Translate text="Request Call" />
                                  </Button>
                                </Popover>

                              ) : null}
                            </div>
                          )}
                        {/* 6-button show */}
                        {(user.user_type === REVIEWSCHEDULER ||
                          user.user_type === VONBOARDER ||
                          user.user_type === VONSCHEDULER) &&
                          (this.state.has_access)
                          && (
                            // this.state.selectedRoleFilter == REVIEWSCHEDULER ||
                            // this.state.selectedRoleFilter == VONBOARDER) && 

                            <div className="btn-container-list">
                              {/* Schedule Appointment btn */}
                              {this.claimButtonVisibility(user, bfile) &&
                                (<Button
                                  type="primary"
                                  className="bg-164897 claim_bfile_margins"
                                  onClick={() => {
                                    const expirationDate =
                                      bfile && bfile.bfile_sub
                                        && bfile.bfile_sub[0] &&
                                        bfile.bfile_sub[0].fs_expiration_date
                                        ? moment(bfile.bfile_sub[0].fs_expiration_date).format("YYYY-MM-DD")
                                        : null;

                                    this.claim(bfile.id, expirationDate)
                                  }}
                                  disabled={claimLoading}
                                >
                                  <Icon type="file-add" /> Claim B File
                                </Button>)}
                              {(this.scheduleAppointmentPermission(user, bfile) &&
                                this.buttoneExpirationPermission(user, bfile)) && (
                                  <button
                                    className="button-size-w-200  text-12 center-button-text btn-bg-FF7152 btn-container-list-btn btn-bg-039C08 "
                                    onClick={() => {
                                      this.schedule_appointmentFunc();
                                    }}
                                  >
                                    <Translate text={`Schedule Appointment`} />
                                  </button>
                                )}
                              {(this.scheduleAppointmentPermission(user, bfile) && this.buttoneExpirationPermission(user, bfile)) && (
                                <button
                                  className="button-size-w-200  text-12 center-button-text btn-bg-FF7152 btn-container-list-btn btn-bg-969696 "
                                  onClick={() => {
                                    this.setState({
                                      not_reached_modal: true
                                    })
                                  }}
                                >
                                  <Translate text={`Not Reached`} />
                                </button>)}
                              {(this.scheduleAppointmentPermission(user, bfile) && this.buttoneExpirationPermission(user, bfile)) && (
                                <button
                                  className="button-size-w-200  text-12 center-button-text btn-bg-FF7152 btn-container-list-btn btn-bg-969696 "
                                  onClick={() => {
                                    this.setState({
                                      not_interested_modal: true
                                    })
                                  }}
                                >
                                  <Translate text={`Not Interested`} />
                                </button>)}
                              {(this.scheduleAppointmentPermission(user, bfile) && this.buttoneExpirationPermission(user, bfile)) && (
                                <button
                                  className="button-size-w-200  text-12 center-button-text btn-bg-FF7152 btn-container-list-btn btn-bg-969696 "
                                  onClick={() => {
                                    this.setState({ not_responsive_modal: true })
                                  }}

                                >
                                  <Translate text={`Non Responsive`} />
                                </button>)}
                              {this.scheduleAppointmentPermission(user, bfile) && (
                                <button
                                  className="button-size-w-200  text-12 center-button-text btn-bg-FF7152 btn-container-list-btn btn-bg-164896 "
                                  onClick={() => {
                                    this.setState({
                                      call_back_requested_modal: true
                                    })
                                  }}
                                >
                                  <Translate text={`Call Back Requested`} />
                                </button>)}
                              {this.scheduleAppointmentPermission(user, bfile) && (
                                <button
                                  // type="danger"
                                  className={`button-size-w-200  text-12 center-button-text btn-bg-FF7152
                             btn-container-list-btn btn-bg-CE0E0E
                        ${this.state.bad_phone_number_status
                                      ? "btn-cursor-not-allowed "
                                      : ""
                                    }
                        `}
                                  onClick={() => this.setState({ bad_phone_number_modal: true })}
                                  // loading={notificationLoading}
                                  disabled={notificationLoading ||
                                    this.state.bad_phone_number_status}
                                >

                                  <Translate text={`Bad Phone Number`} />
                                </button>
                              )}
                            </div>
                          )}
                      </div>
                    )
                  }
                </div>

                {/* mobile responsive btns  */}
                {
                  windowWidth < 800 && (
                    <div>

                      {/* two button show */}
                      {((user.user_type === "EA" && user.id !== 2) ||
                        user.user_type === "LSP") && (


                          <div className="btn-container-customer-profile">
                            <Popover
                              content={LAUNCH_CALCULATOR_POP_OVER}
                              placement="top"
                              trigger={"hover"}
                              overlayStyle={{ marginBottom: "8px" }}
                            >
                              <button
                                className="button-size-w-171 text-12 center-button-text btn-bg-164897 margin-bottom-20"
                                onClick={parentInstance.edit.bind(parentInstance)}
                              >
                                <Translate text={`Edit Calculator`} />
                              </button>
                            </Popover>
                            {/* Update Intelligence Link button */}
                            {/* removed extra filters */}
                            {/* {(user.user_type && user.user_type === "EA") ||
                          (user.user_type === "SUPER_ADMIN" &&
                            parentInstance.props.history.location.state &&
                            parentInstance.props.history.location.state
                              .user_type === "BOBADMIN") ||
                          (user.user_type && user.user_type === "LSP") ? (

                          moved  button from here to top
                        ) : null} */}

                            {/* Request Call button */}
                            {((user.user_type && user.user_type === "EA") ||
                              (user.user_type && user.user_type === "LSP")) ? (
                              // (user.user_type === "SUPER_ADMIN" && parentInstance.props.history.location.state && parentInstance.props.history.location.state.user_type === "BOBADMIN") ||
                              // (user.user_type && user.user_type === "LSP")) && parentInstance.state.isRequestButtonDisable && (parentInstance.state.isRequestButtonDisable.review == 1 || parentInstance.state.isRequestButtonDisable.vonboard == 1) ? (
                              <Button
                                onClick={() =>
                                  parentInstance.setState({
                                    send_followup_modal: true,
                                  })
                                }

                                disabled={
                                  agencyInfo.review == 0 &&
                                  agencyInfo.vonboard == 0
                                }
                                className="button-size-w-171 text-12 center-button-text btn-bg-FF7152"
                                style={{
                                  backgroundColor: "#ff7152",
                                  borderColor: "#ff7152",
                                  color: "#fff",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = "#ff7152";
                                  e.currentTarget.style.borderColor = "#ff7152";
                                  e.currentTarget.style.color = "#fff";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = "#ff7152";
                                  e.currentTarget.style.borderColor = "#ff7152";
                                  e.currentTarget.style.color = "#fff";
                                }}

                              >
                                <Translate text={`Request Call`} />
                              </Button>
                            ) : null}
                          </div>
                        )}
                      {/* 6-button show */}
                      {(user.user_type === REVIEWSCHEDULER ||
                        user.user_type === VONBOARDER ||
                        user.user_type === VONSCHEDULER) && (
                          // this.state.selectedRoleFilter == REVIEWSCHEDULER ||
                          // this.state.selectedRoleFilter == VONBOARDER) && 

                          <div className="btn-container-list">
                            {/* Schedule Appointment btn */}
                            {this.claimButtonVisibility(user, bfile) && (<Button
                              type="primary"
                              className="bg-164897 claim_bfile_margins"
                              onClick={() => {
                                const expirationDate =
                                  bfile && bfile.bfile_sub && bfile.bfile_sub[0] &&
                                    bfile.bfile_sub[0].fs_expiration_date
                                    ? moment(bfile.bfile_sub[0].fs_expiration_date).format("YYYY-MM-DD")
                                    : null;

                                this.claim(bfile.id, expirationDate)
                              }}
                              disabled={claimLoading}
                            >
                              <Icon type="file-add" /> Claim B File
                            </Button>)}
                            {(this.scheduleAppointmentPermission(user, bfile) && this.buttoneExpirationPermission(user, bfile)) && (
                              <button
                                className="button-size-w-200  text-12 center-button-text btn-bg-FF7152 btn-container-list-btn btn-bg-039C08 "
                                onClick={() => {
                                  this.schedule_appointmentFunc();
                                }}
                              >
                                <Translate text={`Schedule Appointment`} />
                              </button>
                            )}
                            {(this.scheduleAppointmentPermission(user, bfile) && this.buttoneExpirationPermission(user, bfile)) && (
                              <button
                                className="button-size-w-200  text-12 center-button-text btn-bg-FF7152 btn-container-list-btn btn-bg-969696 "
                                onClick={() => {
                                  this.setState({
                                    not_reached_modal: true
                                  })
                                }}
                              >
                                <Translate text={`Not Reached`} />
                              </button>)}
                            {(this.scheduleAppointmentPermission(user, bfile) && this.buttoneExpirationPermission(user, bfile)) && (
                              <button
                                className="button-size-w-200  text-12 center-button-text btn-bg-FF7152 btn-container-list-btn btn-bg-969696 "
                                onClick={() => {
                                  this.setState({
                                    not_interested_modal: true
                                  })
                                }}
                              >
                                <Translate text={`Not Interested`} />
                              </button>)}
                            {(this.scheduleAppointmentPermission(user, bfile) && this.buttoneExpirationPermission(user, bfile)) && (
                              <button
                                className="button-size-w-200  text-12 center-button-text btn-bg-FF7152 btn-container-list-btn btn-bg-969696 "
                                onClick={() => {
                                  this.setState({ not_responsive_modal: true })
                                }}

                              >
                                <Translate text={`Non Responsive`} />
                              </button>)}
                            {this.scheduleAppointmentPermission(user, bfile) && (
                              <button
                                className="button-size-w-200  text-12 center-button-text btn-bg-FF7152 btn-container-list-btn btn-bg-164896 "
                                onClick={() => {
                                  this.setState({
                                    call_back_requested_modal: true
                                  })
                                }}
                              >
                                <Translate text={`Call Back Requested`} />
                              </button>)}
                            {this.scheduleAppointmentPermission(user, bfile) && (
                              <button
                                className={`button-size-w-200  text-12 center-button-text btn-bg-FF7152
                             btn-container-list-btn btn-bg-CE0E0E
                        ${this.state.bad_phone_number_status
                                    ? "btn-cursor-not-allowed "
                                    : ""
                                  }
                        `}
                                onClick={() => this.setState({ bad_phone_number_modal: true })}
                                disabled={notificationLoading || this.state.bad_phone_number_status}
                              >

                                <Translate text={`Bad Phone Number`} />
                              </button>
                            )}
                          </div>
                        )}
                    </div>
                  )
                }
                {/* B File Actions */}
                {((user.user_type === "EA" && user.id !== 2) ||
                  user.user_type === "LSP") && (
                    <div className="padding-20">
                      <ActionMenu
                        bfile={bfile}
                        user={user}
                        history={parentInstance.props.history}
                        update={(bfile) => parentInstance.setState({ bfile })}
                        refresh={parentInstance.init.bind(parentInstance)}
                      />
                    </div>
                  )}
              </Col>
              {
                windowWidth > 800 && (
                  <Col span={12} style={{ minHeight: "380px", position: "relative" }}>
                    <div>
                      {/* Add note Div */}
                      <div className="padding-10 add-note-container">
                        {
                          user.user_type != AGENCY_MANAGER && (
                            <button
                              className="customer-profile-note-btn btn-bg-164896 text-12"
                              onClick={() =>
                                parentInstance.setState({ add_note_modal: true })
                              }
                            >
                              <Translate text={`Add Note`} />{" "}
                            </button>
                          )}
                      </div>

                      <div className="internal-btn-container-2">
                        <List
                          loading={notes_loading}
                          itemLayout="horizontal"
                          dataSource={few_notes_copy.slice(0, 1) || []}
                          renderItem={(item, index) => {
                            const notesData = F.getActualNotesAndPostFixData(
                              item.note
                            );

                            const hasNote =
                              notesData.actualNotes &&
                              notesData.actualNotes.trim().length > 0;

                            const actionContainerStyle = !hasNote
                              ? { margin: 0 }
                              : {};

                            return (
                              <List.Item>
                                <div style={{ width: "100%" }}>
                                  <div>
                                    <div className="internal-btn-container  paddinng-bottom-10">
                                      <div
                                        className="internal-btn-container"
                                      // style={{ width: "250px" }}
                                      >
                                        <Tooltip
                                          placement="top"
                                          title={item.user_name.length > 18 ? item.user_name : null}
                                        >
                                          <span
                                            className="text-12 text-color-456DAC font-weight-700 notes-text-span"
                                            style={{
                                              paddingRight: "35px",
                                              maxWidth: "180px",
                                              display: "inline-block",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              cursor: 'pointer'
                                            }}
                                          >
                                            {item.user_name}
                                          </span>
                                        </Tooltip>

                                        <span className="text-12 text-color-456DAC font-weight-700">
                                          {moment(item.created_on).format("MM/DD/YYYY hh:mmA")}
                                        </span>
                                      </div>
                                      {/* internal heading */}
                                      <div>
                                        <button className="internal-btn text-12">
                                          {this.getUserType(item.notes_type)}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  {/* 1 */}
                                  <div style={{ width: "80%" }}>
                                    {item.type_of_call &&
                                      item.type_of_call.length > 0 && (
                                        <div className="notes-second-container padding-top-10  ">
                                          <div className="">
                                            <span className="text-12 font-weight-600 notes-text-span ">
                                              Type of Call:
                                            </span>
                                          </div>
                                          <div className="text-12">
                                            {" "}
                                            {F.transformCallTypeLabel(item.type_of_call)}
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                  {/* 2 */}
                                  <div style={{ width: "80%" }}>
                                    {item.sub_type_of_call &&
                                      item.sub_type_of_call.length > 0 && (
                                        <div className="notes-second-container padding-top-10  ">
                                          <div className="">
                                            <span className="text-12 font-weight-600 notes-text-span ">
                                              Sub Type of Call:
                                            </span>
                                          </div>
                                          <div className="text-12">
                                            {get_label_from_value(
                                              item.sub_type_of_call,
                                              "label",
                                              item.type_of_call
                                            )}
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                  {/* 3 */}
                                  <div style={{ width: "80%" }}>
                                    {item.action && (
                                      <div className="notes-second-container padding-top-10  ">
                                        <div className="">
                                          <span className="text-12 font-weight-600 notes-text-span ">
                                            Action:
                                          </span>
                                        </div>
                                        <div className="text-12">{item.action}</div>
                                      </div>
                                    )}
                                  </div>
                                  {/* 4 */}
                                  <div style={{ width: "100%", marginBottom: 10 }}>
                                    {hasNote && (
                                      <div>
                                        <div className="notes-second-container padding-top-10  ">
                                          <div className="">
                                            <span className="text-12 font-weight-600 notes-text-span ">
                                              Notes:
                                            </span>
                                          </div>
                                          <div className="text-12" style={{ paddingBottom: "10px" }}>
                                            {/* <ReadMore viewTag> */}
                                            <OptimizedReadMore>
                                              {F.stripHtml(F.getActualNotesSubType(
                                                notesData.actualNotes + " " + notesData.postfixNotes,
                                                item.type_of_call
                                              )
                                              )}
                                            </OptimizedReadMore>
                                            {/* </ReadMore> */}
                                          </div>
                                        </div>
                                        {item.referrals.length !== 0 && <Button
                                          className="borderRadius-28"
                                          onClick={() => this.setState({ showreferrals: true, currentReferralsIndex: index })}>Show Referrals</Button>}
                                        {item.referrals.length !== 0 && this.state.showreferrals && <ShowReferrals visible={this.state.showreferrals} handleCancel={() => this.setState({ showreferrals: false })} data={few_notes_copy.slice(0, 2)[this.state.currentReferralsIndex].referrals} />}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </List.Item>
                            );
                          }}
                        />
                      </div>
                      <div className="padding-10 add-note-container"
                        style={{ position: "absolute", bottom: "0px", right: "6px" }}
                      >
                        {notes.length > 1 ? (
                          <button
                            className="customer-profile-note-btn btn-bg-164896 text-12"
                            onClick={() =>
                              parentInstance.setState({ show_notes_modal: true })
                            }
                          >
                            Show more
                          </button>
                        ) : null}
                      </div>
                    </div>
                  </Col>
                )
              }
            </Row>
          </div>
        </div>

        {/* mobile view right part  */}
        {
          // header part
          windowWidth < 800 && (
            <div
              className="card-padding-10 border-radius-10 "
              type="inner"
              // bordered={false}
              loading={loading}
              style={{ background: "#164897", color: "#FFFFFF" }}
            >
              {windowWidth > 800 && <div className="vertical-line" />}
              <Row className="center-content" gutter={32}>
                {/* header right */}
                {
                  windowWidth < 800 && (
                    <Col span={24}>
                      <div
                        style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                      >
                        <div>
                          <span className="padding-5">
                            <img
                              src={dataBaseIcon}
                              alt="notepad"
                              width={20}
                              style={{ marginLeft: "-5px", paddingBottom: "5px" }}
                            />
                          </span>
                          <span className="text-18">Notes</span>
                        </div>
                        <div className="select-container">
                          <Icon type="search" className="search-icon-select" />
                          <Select
                            mode="multiple"
                            className="notes-dropdown"
                            style={{ width: windowWidth > 480 ? 280 : 180, wordBreak: "" }}
                            placeholder="Select Notes Type"
                            defaultValue={[]}
                            value={noteType}
                            onChange={parentInstance.handleChangeNoteType}
                            optionLabelProp="value"
                            maxTagCount={1}
                            suffixIcon={<span>...</span>}
                          // showSearch
                          >
                            <Option value="Internal">
                              <Checkbox checked={noteType.includes("Internal")}>
                                Internal
                              </Checkbox>
                            </Option>
                            <Option value="Review Scheduler">
                              <Checkbox
                                checked={noteType.includes("Review Scheduler")}
                              >
                                Review Scheduler
                              </Checkbox>
                            </Option>
                            <Option value="Follow-up Specialist">
                              <Checkbox
                                checked={noteType.includes("Follow-up Specialist")}
                              >
                                Follow-up Specialist
                              </Checkbox>
                            </Option>
                          </Select>
                        </div>
                      </div>
                    </Col>
                  )
                }
              </Row>
            </div>
          )
        }

        {/* mobile view right part card section */}
        {
          <div className="relative-container ">
            {windowWidth > 800 && <div className="vertical-line-2" />}
            <Row gutter={16}>

              {
                windowWidth < 800 && (
                  <Col span={24} style={{ minHeight: "380px", position: "relative" }}>
                    <div>
                      {/* Add note Div */}
                      <div className="padding-10 add-note-container">
                        {
                          user.user_type != AGENCY_MANAGER && (
                            <button
                              className="customer-profile-note-btn btn-bg-164896 text-12"
                              onClick={() =>
                                parentInstance.setState({ add_note_modal: true })
                              }
                            >
                              <Translate text={`Add Note`} />{" "}
                            </button>
                          )}
                      </div>

                      <div className="internal-btn-container-2">
                        <List
                          loading={notes_loading}
                          itemLayout="horizontal"
                          dataSource={few_notes_copy.slice(0, 1) || []}
                          renderItem={(item, index) => {
                            const notesData = F.getActualNotesAndPostFixData(
                              item.note
                            );

                            const hasNote =
                              notesData.actualNotes &&
                              notesData.actualNotes.trim().length > 0;

                            const actionContainerStyle = !hasNote
                              ? { margin: 0 }
                              : {};

                            return (
                              <List.Item>
                                <div style={{ width: "100%" }}>
                                  <div>
                                    <div className="internal-btn-container  paddinng-bottom-10">
                                      <div
                                        className="internal-btn-container"
                                      // style={{ width: "250px" }}
                                      >
                                        <span className="text-12 text-color-456DAC font-weight-700  notes-text-span"
                                        // style={{paddingRight: "27px"}}
                                        >
                                          {item.user_name}
                                          {/* Sharon Ferrett */}
                                        </span>
                                        <span className="text-12 text-color-456DAC font-weight-700">
                                          {moment(item.created_on).format("MM/DD/YYYY hh:mmA")}
                                        </span>
                                      </div>
                                      {/* internal heading */}
                                      <div>
                                        <button className="internal-btn text-12">
                                          {this.getUserType(item.notes_type)}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  {/* 1 */}
                                  <div style={{ width: "80%" }}>
                                    {item.type_of_call &&
                                      item.type_of_call.length > 0 && (
                                        <div className="notes-second-container padding-top-10  ">
                                          <div className="">
                                            <span className="text-12 font-weight-600 notes-text-span ">
                                              Type of Call:
                                            </span>
                                          </div>
                                          <div className="text-12">
                                            {" "}
                                            {F.transformCallTypeLabel(item.type_of_call)}
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                  {/* 2 */}
                                  <div style={{ width: "80%" }}>
                                    {item.sub_type_of_call &&
                                      item.sub_type_of_call.length > 0 && (
                                        <div className="notes-second-container padding-top-10  ">
                                          <div className="">
                                            <span className="text-12 font-weight-600 notes-text-span ">
                                              Sub Type of Call:
                                            </span>
                                          </div>
                                          <div className="text-12">
                                            {get_label_from_value(
                                              item.sub_type_of_call,
                                              "label",
                                              item.type_of_call
                                            )}
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                  {/* 3 */}
                                  <div style={{ width: "80%" }}>
                                    {item.action && (
                                      <div className="notes-second-container padding-top-10  ">
                                        <div className="">
                                          <span className="text-12 font-weight-600 notes-text-span ">
                                            Action:
                                          </span>
                                        </div>
                                        <div className="text-12">{item.action}</div>
                                      </div>
                                    )}
                                  </div>
                                  {/* 4 */}
                                  <div style={{ width: "100%", marginBottom: 10 }}>
                                    {hasNote && (
                                      <div>
                                        <div className="notes-second-container padding-top-10  ">
                                          <div className="">
                                            <span className="text-12 font-weight-600 notes-text-span ">
                                              Notes:
                                            </span>
                                          </div>
                                          <div className="text-12" style={{ paddingBottom: "10px" }}>
                                            {/* <ReadMore viewTag> */}
                                            <OptimizedReadMore>
                                              {F.stripHtml(F.getActualNotesSubType(
                                                notesData.actualNotes + " " + notesData.postfixNotes,
                                                item.type_of_call
                                              )
                                              )}
                                            </OptimizedReadMore>
                                            {/* </ReadMore> */}
                                          </div>
                                        </div>
                                        {item.referrals.length !== 0 && <Button
                                          className="borderRadius-28"
                                          onClick={() => this.setState({ showreferrals: true, currentReferralsIndex: index })}>Show Referrals</Button>}
                                        {item.referrals.length !== 0 && this.state.showreferrals && <ShowReferrals visible={this.state.showreferrals} handleCancel={() => this.setState({ showreferrals: false })} data={few_notes_copy.slice(0, 2)[this.state.currentReferralsIndex].referrals} />}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </List.Item>
                            );
                          }}
                        />
                      </div>
                      <div className="padding-10 add-note-container"
                        style={{ position: "absolute", bottom: "0px", right: "6px" }}
                      >
                        {notes.length > 1 ? (
                          <button
                            className="customer-profile-note-btn btn-bg-164896 text-12"
                            onClick={() =>
                              parentInstance.setState({ show_notes_modal: true })
                            }
                          >
                            Show more
                          </button>
                        ) : null}
                      </div>
                    </div>
                  </Col>
                )
              }
            </Row>
          </div>
        }


        {this.state.setup_appointment_modal && this.props.bfile ? (
          <SetupAppointment
            history={this.props.history}
            showModal={this.state.setup_appointment_modal}
            hideModal={() => this.setState({ setup_appointment_modal: false })}
            bfile={this.props.bfile}
            user={user}
            // {...this.props}
            {...this.props.otherProps}
          />
        ) : null}
        {this.state.setup_appointment_modal_von && this.props.bfile ? (
          <SetupAppointmentVon
            history={this.props.history}
            showModal={this.state.setup_appointment_modal_von}
            hideModal={() =>
              this.setState({ setup_appointment_modal_von: false })
            }
            bfile={this.props.bfile}
            user={user}
            // {...this.props}
            {...this.props.otherProps}
          />
        ) : null}
        {/* Appointment Action Modal when user clicks on not interested */}
        {
          this.state.not_interested_modal && this.props.bfile ? (
            <AppointmentActionModal
              title="Not Interested"
              showModal={this.state.not_interested_modal}
              hideModal={() => this.setState({ not_interested_modal: false })}
              bfile={this.props.bfile}
              user={user}
              action="2"
              init={this.props.init}
              history={this.props.history}

              {...this.props.otherProps}
            />
          ) : null
        }
        {/* Appointment Action Modal when user clicks on not reached */}
        {
          this.state.not_reached_modal && this.props.bfile ? (
            <AppointmentActionModal
              title="Not Reached"
              showModal={this.state.not_reached_modal}
              hideModal={() => this.setState({ not_reached_modal: false })}
              bfile={this.props.bfile}
              user={user}
              action="1"
              init={this.props.init}
              history={this.props.history}


              {...this.props.otherProps}
            />
          ) : null
        }
        {/* Appointment Action Modal when user clicks on not Responsive */}
        {
          this.state.not_responsive_modal && this.props.bfile ? (
            <AppointmentActionModal
              title="Non Responsive"
              showModal={this.state.not_responsive_modal}
              hideModal={() => this.setState({ not_responsive_modal: false })}
              bfile={this.props.bfile}
              user={user}
              action="3"
              init={this.props.init}
              history={this.props.history}


              {...this.props.otherProps}
            />
          ) : null
        }
        {/* Appointment Action Modal when user clicks on call back requested */}

        {
          this.state.call_back_requested_modal && this.props.bfile ? (
            <CallBackRequestedModal
              title="Call Back Requested"
              showModal={this.state.call_back_requested_modal}
              hideModal={() => this.setState({ call_back_requested_modal: false })}
              bfile={this.props.bfile}
              init={this.props.init}
              history={this.props.history}

              user={user}
              {...this.props.otherProps}
            />
          ) : null
        }

        <Modal
          title="Bad Phone Number"
          visible={this.state.bad_phone_number_modal}
          okText="Save"
          confirmLoading={notificationLoading}
          cancelButtonProps={{
            className: 'borderRadius-28',
          }}
          okButtonProps={{
            className: 'borderRadius-28 bg-164897',
            style: {
              color: 'white'
            },
            disabled: this.state.bad_phone_number_reason.length === 0
          }}
          onOk={() => this.sendNotification(bfile)}
          onCancel={() => this.setState({
            bad_phone_number_modal: false,
            bad_phone_number_reason: ""
          })}
          destroyOnClose
        >
          <label style={{ fontWeight: 400, fontSize: 14, color: "#000", marginBottom: '10px' }}>
            <Translate text={`Add a Reason`} />
            <span className="asteriskIcon">*</span>
          </label>
          <Input.TextArea
            className="bad-phone-reason-input"
            value={this.state.bad_phone_number_reason}
            maxLength={250}
            rows={4}
            placeholder="Add a reason to mark bad phone number"
            onChange={(event) => this.setState({
              bad_phone_number_reason: event.target.value
            })}
          />
          <div style={{ marginTop: 4, textAlign: "right", color: "#999" }}>
            {this.state.bad_phone_number_reason.length}/250
          </div>
        </Modal>


      </div >
    );
  }
}

export default CustomerProfile;



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/components/CustomerProfile.js